/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Paragraph_0Inputs */

const en_visa_o1_paragraph_0 = /** @type {(inputs: Visa_O1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O-1 filings are evidence-driven. The applicable standards depend on the field and the type of work involved, and some cases may rely on comparable evidence where permitted.`)
};

const pt_visa_o1_paragraph_0 = /** @type {(inputs: Visa_O1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As apresentações O-1 são baseadas em evidências. Os padrões aplicáveis dependem do campo e do tipo de trabalho envolvido, e alguns casos podem se apoiar em evidência comparável quando permitido.`)
};

const es_visa_o1_paragraph_0 = /** @type {(inputs: Visa_O1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las presentaciones O-1 se basan en evidencia. Los estándares aplicables dependen del campo y del tipo de trabajo involucrado, y algunos casos pueden apoyarse en evidencia comparable cuando se permite.`)
};

/**
* | output |
* | --- |
* | "O-1 filings are evidence-driven. The applicable standards depend on the field and the type of work involved, and some cases may rely on comparable evidence w..." |
*
* @param {Visa_O1_Paragraph_0Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_paragraph_0 = /** @type {((inputs?: Visa_O1_Paragraph_0Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Paragraph_0Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_paragraph_0(inputs)
	if (locale === "es") return es_visa_o1_paragraph_0(inputs)
	return en_visa_o1_paragraph_0(inputs)
});